<template>
    <div>
        <MenuMember/>
        <AdminList/>
    </div>
</template>

<script>
import MenuMember from '@/components/admin/member/menumember/MenuMember.vue'
import AdminList from '@/components/admin/member/admin/AdminList.vue'

export default {
    name:'admin',
    components:{
        MenuMember,
        AdminList,
    }
}
</script>